import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { axiosPrivate } from "../api/axios";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";
import { redirectToLogin } from "../utils/redirect";

const useAxiosPrivate = () => {
  const location = useLocation();
  const refresh = useRefreshToken();
  const { auth } = useAuth();

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      config => {
        if (!config.headers['Authorization']) {
          config.headers['Authorization'] = `Bearer ${auth.accessToken}`;
        }
        return config;
      }, (error) => Promise.reject(error)
    );
    
    const responseIntercept = axiosPrivate.interceptors.response.use(
      response => response,
      async (error) => {
        const prevRequest = error?.config;

        if (error?.response?.status === 403) {
          if (!prevRequest?.sent) {
            prevRequest.sent = true;
            try {
              const newAccessToken = await refresh();
              prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
              return axiosPrivate(prevRequest);
            } catch (refreshError) {
              redirectToLogin(location);
            }
          } else {
            redirectToLogin(location);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, [auth, location, refresh]);

  return axiosPrivate;
};

export default useAxiosPrivate;
